import { ToastContainer } from "../../components/Common";
import DeviceWarrantyRegistration from "./page";

const DeviceWarrantyRegistrationPageWrapper = () => {
    return (
        <>
            <div className="page-content">
                <DeviceWarrantyRegistration />
            </div>
            <ToastContainer />
        </>
    );
};

export default DeviceWarrantyRegistrationPageWrapper;
